import { createRouter, createWebHistory } from 'vue-router'
import home from '../views/home.vue'
import Softwaresys  from '../views/Product/Softwaresys.vue'
import Case  from '../views/Case.vue'
import CloudWarehouse  from '../views/Product/CloudWarehouse.vue'
import hardware  from '../views/Product/hardware.vue'
import Products  from '../views/Products.vue'
import CompanyProfile  from '../views/CompanyProfile.vue'
import information  from '../views/information.vue'
import desktopRedcode  from '../views/information/desktopReadcode.vue'
import trayCalibrationMachine from '../views/information/trayReadcode.vue'
import WholePieceReadcode from '../views/information/WholePieceReadcode.vue'
import JoinUs from '../views/JoinUs.vue'
const routes = [
  {
    path: '/',
    name: 'home',
    component: home
  },{
    path: '/Softwaresys',
    name: 'Softwaresys',
    component: Softwaresys
  },{
    path: '/Case',
    name: 'Case',
    component: Case
  },{
    path: '/CloudWarehouse',
    name: 'CloudWarehouse',
    component: CloudWarehouse
  },{
    path: '/hardware',
    name: 'hardware',
    component: hardware
  },{
    path: '/Products',
    name: 'Products',
    component: Products
  },{
    path: '/CompanyProfile',
    name: 'CompanyProfile',
    component: CompanyProfile
  },{
    path: '/information',
    name: 'information',
    component: information
  },{
    path: '/desktopRedcode',
    name: 'desktopRedcode',
    component: desktopRedcode
  },{
    path: '/trayCalibrationMachine',
    name: 'trayCalibrationMachine',
    component: trayCalibrationMachine
  },{
    path: '/WholePieceReadcode',
    name: 'WholePieceReadcode',
    component: WholePieceReadcode
  },{
    path: '/JoinUs',
    name: 'JoinUs',
    component: JoinUs
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
